export interface LeadData {
  name: string
  email: string
  phone: string
  course: string
}

// 🔧 Paste your Google Apps Script Web App URL here after deploying.
// It should look like: https://script.google.com/macros/s/AKfycb.../exec
export const GOOGLE_APPS_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbw0Txxqb4MfvKoBE4kIc3h5ySldZ7bRTprfE69v3BffpqdVUH8x3wuTqG-kVxl9atRh/exec'

/**
 * Send a lead to the Google Sheet via the Apps Script web app.
 *
 * We use mode: 'no-cors' so the browser doesn't require CORS preflight on
 * the Apps Script endpoint (Apps Script web apps don't return CORS headers
 * by default). This makes the response opaque, so we treat the request as
 * fire-and-forget — we never block the user's payment flow on the network.
 */
export async function submitLead(lead: LeadData): Promise<void> {
  if (
    !GOOGLE_APPS_SCRIPT_URL ||
    GOOGLE_APPS_SCRIPT_URL === 'PASTE_YOUR_APPS_SCRIPT_URL_HERE'
  ) {
    // Not configured yet — log so devs see it, but don't block enrolment.
    console.warn(
      '[leadCapture] GOOGLE_APPS_SCRIPT_URL is not set. Lead was not saved:',
      lead,
    )
    return
  }

  try {
    await fetch(GOOGLE_APPS_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8',
      },
      body: JSON.stringify({
        ...lead,
        timestamp: new Date().toISOString(),
        source: typeof window !== 'undefined' ? window.location.href : '',
      }),
    })
  } catch (err) {
    // Swallow network errors — never block the user.
    console.error('[leadCapture] Failed to submit lead', err)
  }
}
